import { env } from "build/env";
import { createLoyaltyCapabilities } from "./loyaltyCapabilities";
export const loyaltyCapabilities = createLoyaltyCapabilities({
  storeViewCode: env.store_view_code,
  isCouponActive: env.IS_COUPON_ACTIVE,
  isEdenredWalletActive: env.IS_EDENRED_WALLET_ACTIVE,
  chTermsUrl: env.CH_LOYALTY_TERMS_URL,
  chPrivacyUrl: env.CH_LOYALTY_PRIVACY_URL
});
export default loyaltyCapabilities;